export default "__VITE_ASSET__TIN4aVhl__"